/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_LostInputs */

const cs_reports_col_lost = /** @type {(inputs: Reports_Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohrané`)
};

const en_reports_col_lost = /** @type {(inputs: Reports_Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost`)
};

/**
* | output |
* | --- |
* | "Lost" |
*
* @param {Reports_Col_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_lost = /** @type {((inputs?: Reports_Col_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_lost(inputs)
	return cs_reports_col_lost(inputs)
});